import { DefaultEndNode } from "./DefaultEndNode";
import { ArchiveConversationNode } from "./ArchiveConversationNode";
import { WebhookNotificationNode } from "./WebhookNotification";
import { EndNodeType } from "../../models/endNode";

export const EndNodeTypeSettings = {
  [EndNodeType.Default]: (props) => <DefaultEndNode {...props} />,
  [EndNodeType.ArchiveConversation]: (props) => (
    <ArchiveConversationNode {...props} />
  ),
  [EndNodeType.WebhookNotification]: (props) => (
    <WebhookNotificationNode {...props} />
  ),
};
